import { render } from "./VariableSegmentedButton.vue?vue&type=template&id=1543136d&scoped=true"
import script from "./VariableSegmentedButton.vue?vue&type=script&lang=js"
export * from "./VariableSegmentedButton.vue?vue&type=script&lang=js"

import "./VariableSegmentedButton.vue?vue&type=style&index=0&id=1543136d&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1543136d"

export default script